var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "patient_list",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    transform: "translate(-171.577 -667.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    d: "M202.021 675.1h-18.887a1.558 1.558 0 0 0-1.557 1.557v23.453a1.558 1.558 0 0 0 1.557 1.557h18.887a1.558 1.558 0 0 0 1.557-1.557v-23.454a1.558 1.558 0 0 0-1.557-1.556zm.519 25.009a.519.519 0 0 1-.519.519h-18.887a.519.519 0 0 1-.519-.519v-23.453a.52.52 0 0 1 .519-.519h18.887a.519.519 0 0 1 .519.519v23.453z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    transform: "translate(187.803 677.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    d: "M222.785 691.495a4.771 4.771 0 0 0-3.275 8.243.508.508 0 0 0 .056.052 4.764 4.764 0 0 0 6.438 0 .543.543 0 0 0 .056-.052 4.771 4.771 0 0 0-3.275-8.243zm0 8.509a3.716 3.716 0 0 1-2.257-.761 2.594 2.594 0 0 1 4.513 0 3.716 3.716 0 0 1-2.256.757zm-.83-3.943v-.337a.83.83 0 1 1 1.66 0v.337a.83.83 0 1 1-1.66 0zm3.836 2.422a3.6 3.6 0 0 0-1.529-1.281 1.859 1.859 0 0 0 .39-1.141v-.337a1.868 1.868 0 1 0-3.736 0v.337a1.859 1.859 0 0 0 .39 1.141 3.6 3.6 0 0 0-1.529 1.281 3.736 3.736 0 1 1 6.013 0z",
    className: "cls-3",
    transform: "translate(-218.011 -691.495)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    transform: "translate(188.176 696.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    d: "M230.127 800.082h-9.419a.519.519 0 0 0 0 1.038h9.419a.519.519 0 0 0 0-1.038z",
    className: "cls-3",
    transform: "translate(-220.19 -800.082)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    transform: "translate(188.176 692.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    d: "M230.127 778.079h-9.419a.519.519 0 0 0 0 1.038h9.419a.519.519 0 0 0 0-1.038z",
    className: "cls-3",
    transform: "translate(-220.19 -778.079)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    transform: "translate(185.959 689.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    d: "M208.105 757.229a.519.519 0 1 0 .152.367.523.523 0 0 0-.152-.367z",
    className: "cls-3",
    transform: "translate(-207.219 -757.077)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    transform: "translate(185.959 692.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    d: "M208.105 778.231a.518.518 0 1 0 .152.367.524.524 0 0 0-.152-.367z",
    className: "cls-3",
    transform: "translate(-207.219 -778.079)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    transform: "translate(185.959 696.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    d: "M208.105 800.234a.518.518 0 1 0 .152.367.524.524 0 0 0-.152-.367z",
    className: "cls-3",
    transform: "translate(-207.219 -800.082)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    transform: "translate(188.176 689.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    d: "M230.127 757.077h-9.419a.519.519 0 0 0 0 1.038h9.419a.519.519 0 0 0 0-1.038z",
    className: "cls-3",
    transform: "translate(-220.19 -757.077)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientList);
export default __webpack_public_path__ + "static/media/patient_list.c72b0db2.svg";
export { ForwardRef as ReactComponent };